/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Modification de la valeur d'une variable dans le contexte d'un tunnel.
 * @export
 * @interface UpdateVariableValueCommand
 */
export interface UpdateVariableValueCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateVariableValueCommand
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateVariableValueCommand
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateVariableValueCommand
     */
    possibleValues?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateVariableValueCommand
     */
    isUserConfigurable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateVariableValueCommand
     */
    unite?: string | null;
}

/**
 * Check if a given object implements the UpdateVariableValueCommand interface.
 */
export function instanceOfUpdateVariableValueCommand(value: object): value is UpdateVariableValueCommand {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UpdateVariableValueCommandFromJSON(json: any): UpdateVariableValueCommand {
    return UpdateVariableValueCommandFromJSONTyped(json, false);
}

export function UpdateVariableValueCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateVariableValueCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'value': json['value'],
        'possibleValues': json['possibleValues'] == null ? undefined : json['possibleValues'],
        'isUserConfigurable': json['isUserConfigurable'] == null ? undefined : json['isUserConfigurable'],
        'unite': json['unite'] == null ? undefined : json['unite'],
    };
}

export function UpdateVariableValueCommandToJSON(json: any): UpdateVariableValueCommand {
    return UpdateVariableValueCommandToJSONTyped(json, false);
}

export function UpdateVariableValueCommandToJSONTyped(value?: UpdateVariableValueCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'value': value['value'],
        'possibleValues': value['possibleValues'],
        'isUserConfigurable': value['isUserConfigurable'],
        'unite': value['unite'],
    };
}

